export const CRASH_ROUND_INFO = `
  query RoundInfo($roundId: String!) {
    crash {
      roundInfo(roundId: $roundId) {
        status
        success
        message
        code
        data {
          roundId
          seed
          crashMultiplier
          interrupted
          derivedCrashMultiplier
          hash
          round
          seedQuota
          createdAt
          hex
          decimal
          gameCode
          gameMode
          epochId
          serverSeedHash
          serverSeed
          seedStatus
          seedRevealedAt
          maxRawOutcome
          maxMultiplierCap
          houseEdge
          separator
          provablyFairVersion
          clientSeeds {
            slot
            clientSeed
            source
            playerId
            acceptedAt
          }
        }
      }
    }
  }
`

// Live commitment for the active global server seed + the algorithm parameters
// the client verifies against. Public — returns no in-use secret.
export const CRASH_PROVABLY_FAIR = `
  query CrashProvablyFair($gameCode: String, $gameMode: String) {
    crash {
      provablyFair(gameCode: $gameCode, gameMode: $gameMode) {
        status
        success
        message
        code
        data {
          seedModel
          gameCode
          gameMode
          gameSeed
          maxRawOutcome
          maxMultiplierCap
          houseEdge
          separator
          algorithm
          provablyFairVersion
          clientSeedSlots
        }
      }
    }
  }
`

// Contribute one client seed to the round in play (provably fair v2).
//
// Authenticated: the backend attributes the seed to the token's player, which is
// what makes "one slot per player" enforceable. The round is resolved server-side;
// `roundId` here is correlation only and is rejected if it is not the open round.
export const CRASH_SEND_CLIENT_SEED = `
  mutation SendClientSeed($input: CrashClientSeedInput!) {
    crash {
      sendClientSeed(input: $input) {
        status
        success
        message
        code
        data {
          accepted
          slot
          reason
          seedCount
          roundId
        }
      }
    }
  }
`
